var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
/**
 * ErrorBoundary is a React component that catches JavaScript errors anywhere in its child component tree,
 * logs those errors, and displays a fallback UI instead of the component tree that crashed.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    /**
     * Creates an instance of ErrorBoundary.
     * @param {Object} props - The properties passed to the component.
     * @constructor
     */
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: null };
        return _this;
    }
    /**
     * A lifecycle method that is invoked after an error has been thrown by a descendant component.
     * It is used to update the state so the next render shows the fallback UI.
     */
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    /**
     * Lifecycle method that is called when an error is thrown in a child component.
     */
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error("Error caught in Error Boundary: ", error, errorInfo);
    };
    /**
     * Renders the component.
     * If an error has been caught in the error boundary, it displays an error message.
     * Otherwise, it renders the child components.
     */
    ErrorBoundary.prototype.render = function () {
        if (this.state.error !== null) {
            return (React.createElement("div", { className: 'tw-p-3 tw-border-[1.5px] tw-rounded-lg tw-flex tw-flex-col tw-gap-[6px] tw-border-red-500 tw-bg-red-700/25' },
                React.createElement("h3", { className: "tw-font-semibold tw-text-lg tw-mb-0" }, "Something went wrong. Please try again."),
                React.createElement("p", { className: "tw-text-sm tw-mb-0 tw-font-mono" }, this.state.error.message)));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
